module.exports = __webpack_public_path__ + "static/media/newyork-3d-city.62f4e0f8.jpg";